// Mulberry32 seeded PRNG - fast and good quality for games
export class SeededRandom {
  private state: number;

  constructor(seed: number) {
    this.state = seed;
  }

  // Returns a random float in [0, 1)
  next(): number {
    this.state |= 0;
    this.state = (this.state + 0x6d2b79f5) | 0;
    let t = Math.imul(this.state ^ (this.state >>> 15), 1 | this.state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  // Returns a random integer in [min, max)
  nextInt(min: number, max: number): number {
    return Math.floor(this.next() * (max - min)) + min;
  }

  // Shuffle an array in place
  shuffle<T>(array: T[]): T[] {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(this.next() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  // Reset with a new seed
  setSeed(seed: number): void {
    this.state = seed;
  }
}

// Global instance with default seed
let globalRng = new SeededRandom(12345);

export function setGlobalSeed(seed: number): void {
  globalRng.setSeed(seed);
}

export function random(): number {
  return globalRng.next();
}

export function randomInt(min: number, max: number): number {
  return globalRng.nextInt(min, max);
}

export function shuffle<T>(array: T[]): T[] {
  return globalRng.shuffle(array);
}
